export function extractProspectAndInterestIds(inputString = '') {
  const result = {
    text: '',
    prospectIds: [],
    interestIds: []
  }
  try {
    // Match the interest IDs section
    result.interestIds =
      inputString.match(/\b[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}\b/g) ||
      []
    const tempString = inputString.replace(result.interestIds?.join(' '), '') // Remove interest IDs from the string
    // Match the prospect IDs section

    const prospectRegex = /prospect\s*IDs?.*?:\s*([\d,\s]+)/i
    const prospectMatch = prospectRegex.exec(tempString)
    if (prospectMatch?.[1]) {
      result.prospectIds = prospectMatch[1]
        .split(',')
        .map((id) => id.trim().toString())
        .filter((id) => id !== '')
    }

    const textMatch = inputString.replace(result.prospectIds?.join(' '), '')
    if (textMatch?.[1]) {
      result.text = textMatch[1].trim() // Trim whitespace
    }
  } catch (error) {
    console.error('Error extracting IDs:', error)
  }

  return result
}
